import { makeStyles } from '~/UIKit/Style';
import { BORDER_COLOR, PRIMARY_BLUE, LIGHT_BLUE, NOTE_RED } from '~/Constants/Colors.constants';

export const SportCategoryListStyles = () =>
  makeStyles((theme) => ({
    content: {
      padding: '0 15px',
    },
    infoText: {
      margin: '5px 0',
      fontSize: 12,
      lineHeight: '16px',
    },
    note: {
      background: LIGHT_BLUE,
      borderTop: `1px solid ${BORDER_COLOR}`,
      borderBottom: `1px solid ${BORDER_COLOR}`,
      margin: '0 -15px',
      padding: 15,
    },
    noteHighlighted: {
      color: NOTE_RED,
    },
    searchContainer: {
      margin: '0 -15px',
    },
    sportCategoryTypeList: {
      borderTop: `1px solid ${BORDER_COLOR}`,
      margin: '0 -15px',
      padding: 0,
    },
    sportCategoryTypeListItem: {
      borderBottom: `1px solid ${BORDER_COLOR}`,
      height: 60,
      '& .MuiTouchRipple-child': {
        backgroundColor: PRIMARY_BLUE,
      },
    },
    sportCategoryTypeTitle: {
      '& .MuiListItemText-primary': {
        fontWeight: 'bold',
      },
    },
    radioGroup: {
      marginLeft: 'auto',
    },
    radio: {
      marginRight: 0,
    },
    popoverPaper: {
      maxHeight: '400px',
    },
    popover: {
      marginLeft: theme.spacing(4),
    },
  }));
